import React from 'react';
import NewContact from './NewContact';

const EditContact = ({ organizations, orgID, contactID }) => {
	return (
		<NewContact
			organizations={organizations}
			orgID={orgID}
			contactID={contactID}
			isEdit={true}
		/>
	);
};

export default EditContact;
